import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import NodataAvailable from "../../../../../Common/NodataAvailable";

const SuggestedCategory = ({ headerStyle }) => {

  const { imageCdnUrl } = useContext(serverInfo);

  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`/api/view-category`).then((res) => {
      if (res.status === 200) {
        setCategoryList(res.data.sugg_category);
      }
      setLoading(false);
    });
  }, []);

  var viewCategory = "";

  if (loading) {
    //return <h5>Loading Category...</h5>
  } else {
    viewCategory = categoryList.map((item, index) => {
      return (
        <>
          <div className="col-sm-6 col-md-6 col-lg-4 mb-3">
            <div className="card p-2 category-card">
              <img
                src={item.image == null ?'https://d35vkepp4dfq5y.cloudfront.net/demo/3502688.png': imageCdnUrl+item.image}
                className="ImgCat"
                alt={imageCdnUrl + item?.image}
                height="220px"
              />

              <Link to={`/category-view/${item.slug}`}>
                <div className="CatBgS ">
                  <h6 className="centeredASd fw-bold">
                    <i className="fas fa-film"></i>&nbsp;
                    {item.name}
                  </h6>
                </div>
              </Link>
            </div>
          </div>
        </>
      );
    });
  }

  return (
    <>
      {categoryList.length === 0 ? (
        <>
          {/* <h2 className="mb-3  text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
            Suggested List
          </h2>
          <NodataAvailable /> */}
        </>
      ) : (
        <>
          <h2 className="mb-3  text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
            Suggested List
          </h2>

          <div className="col-md-12 mt-3">
            <div className="row">{viewCategory}</div>
          </div>
        </>
      )}
    </>
  );
};

export default SuggestedCategory;
